(function () {

  if (document.querySelectorAll('.fb-page').length == 0) return this;

  window.onload = function(){
    window.FB.XFBML.parse();
  }
  //onresize
})();
